export default "__VITE_ASSET__ef5e8a1d__"